import React from 'react';
import { connect } from 'react-redux';
import Flujo from './flujo.cmpt'
import Mapa from './mapa.cmpt'
import { goTo } from "../tools";
import { iframeResizer as iframeResizerLib } from 'iframe-resizer';
import ReactResizeDetector from 'react-resize-detector';
import PropTypes from 'prop-types';
import { servicios } from '../properties';

const ubicacionN = require("../img/localizaN.svg");

const mapState = (state) => {
    return {
        loading: state.global.loading,
        paso: state.directorio.paso,
        cliente: state.global.clienteUnico,
        tid: state.global.tid 
    };
}

const mapDispatch = (dispatch) => {
    return {
        pasoReset: () => {
            dispatch({ "type": "DIRECTORIO_PASO", "paso": 0 })
        },
        alerta: (sTitulo, sMensaje, sNameBtnCancel, fnCancel, sNameBtnConfirm, fnConfirm, sCode) => {
            dispatch({ "type": "MODAL_ALERT_CONFIRM", "titulo": sTitulo, "mensaje": sMensaje, "nameBtnCancel": sNameBtnCancel, "accionCancel": fnCancel, "nameBtnConfirm": sNameBtnConfirm, "accionConfirm": fnConfirm, "codigo": sCode });
		}
    }
}

class Directorio extends React.Component {

    state = {
		ingresoHospitalario : false,
        valoresIngresoHospitalario : null,
        tabActivaStr : "ingresoHospitalario"
    }

    transformarPlanes(idPlan) {
        console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@ transformarPlanes");
        let planVerdadero = idPlan;
        let planesSubplanesJSON = JSON.parse(localStorage.getItem("planesSubplanesGNP"));
        try {
            planesSubplanesJSON.map((psj) => {
                if(psj.idplan !== idPlan) {
                    let subplanes = psj.subplanes;
                    if(subplanes !== "") {
                        let subplanesArray = subplanes.split(",");
                        for(let i = 0; i < subplanesArray.length; i++) {
                            if(Number(subplanesArray[i]) === Number(idPlan)) {
                                planVerdadero = psj.idplan;
                                break;
                            }
                        }
                    }
                }
            });
        } catch(e) {
            console.log(e);
        }
        return planVerdadero;
    }

    validaHospital1 = (el) => {
        let planSeleccionado = parseInt(localStorage.getItem("planValue"));
        let valido = false;
        let planesCliente = localStorage.getItem("planesCliente").replace("|", "");
        let planesClienteArray = planesCliente.split("|");
        let str = "";
        for(let a = 0; a < planesClienteArray.length; a++) {
            str = str + planesClienteArray[a] + ",";
        }
        str = str.substring(0, str.length - 1);
        let planesC = JSON.parse("{\"planesClientes\": [" + str +  "]}");
        planesC.planesClientes.map((p) => {
            let planes = el.planes.split(",");
            for(let a = 0; a < planes.length; a++) {
                if(p.cvePlan > 22) {
                    if(Number(this.transformarPlanes(p.cvePlan)) === Number(planes[a]) || Number(p.cvePlan) === Number(planes[a])) {
                        valido = true;
                    }
                } else {
                    if(Number(p.cvePlan) === Number(planes[a])) {
                        valido = true;
                    }
                }
            }
        });
        return valido;
    }

    redireccionarIngresoHospitalario = (ingresoHospitalario,valoresIngresoHospitalario) => {
        let hospitalDentroPlan = this.validaHospital1(JSON.parse(valoresIngresoHospitalario));
        let sTitulo = hospitalDentroPlan ? "El hospital seleccionado se encuentra dentro del nivel hospitalario contratado en tu póliza." : "El hospital seleccionado no pertenece al nivel hospitalario contratado en la póliza";
        let sMensaje = hospitalDentroPlan ? "" : "Por lo que se pueden generar gastos adicionales no cubiertos.";
        let sNameBtnCancel = "Cambiar de hospital";
        let fnCancel = undefined;
        let sNameBtnConfirm = "Confirmar hospital";
        let fnConfirm = () => {

            document.getElementById("directorioMenuGMM").className = "";

            document.getElementById("tramitesMenuGMM").className = "active";

            window.localStorage.setItem("ingresoHospitalario", ingresoHospitalario);

            window.localStorage.setItem("valoresIngresoHospitalario", valoresIngresoHospitalario);

            goTo("seguimiento-siniestros");

        };
        let sCode = "MAC";
        this.props.alerta(sTitulo, sMensaje, sNameBtnCancel, fnCancel, sNameBtnConfirm, fnConfirm, sCode);

    }
    
    componentWillMount = () => {
        this.props.pasoReset();
        let planesId = "";
        let planesCliente = localStorage.getItem("planesCliente");
        if(planesCliente) {
            console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ en el if");
            console.log("planesCliente= " + planesCliente);
            planesCliente = planesCliente.replace("|", "");
            let planesClienteArray = planesCliente.split("|");
            let str = "";
            for(let a = 0; a < planesClienteArray.length; a++) {
                str = str + planesClienteArray[a] + ",";
            }
            str = str.substring(0, str.length - 1);
            let planesC = JSON.parse("{\"planesClientes\": [" + str +  "]}");
            planesC.planesClientes.map((p) => {
                planesId = planesId + "{\"nombre\":\"" + p.planComercial +"\", \"poliza\":\"" + p.numPoliza +"\"},";
            });
            planesId = planesId.substring(0, planesId.length - 1);
            planesId = "[" + planesId + "]";
            this.setState({"planesCliente": JSON.parse(planesId)});
        }
        console.log("Termino el will mount");
    }

    resizeIframe = () => {
        const { iFrame } = this.refs;        
		if (!iFrame) return;
		this.iframeResizer = iframeResizerLib({
			log: false,
			heightCalculationMethod: 'taggedElement',
			autoResize: true
		}, iFrame);
	}

    componentDidMount = () => {
        let directorio = document.getElementById("directorio-frame");
        directorio.setAttribute("allow", "geolocation");
        var parentDiv = directorio.parentNode;
        parentDiv.replaceChild(document.getElementById("directorio-frame"),directorio);
    }
    
	onLoadIframe = () => {
        window.addEventListener('message',function(message){
            if(message.data.type=="ingreso.hospitalario"){
            document.getElementById("directorioMenuGMM").className = "";
            document.getElementById("tramitesMenuGMM").className = "active";
            window.localStorage.setItem("ingresoHospitalario", message.data.ingreso);
            window.localStorage.setItem("valoresIngresoHospitalario", JSON.stringify(message.data.valores));
            goTo("seguimiento-siniestros");
            }
        });

		this.resizeIframe();
	}
    
    
    getSrcDirectorio(){
        let directorio = servicios.directorioFrame.endPoint;
        
        if(this.props && this.props.cliente){
            directorio = directorio + 'origen' + '=' + 'cliente'+ '&'  + 'clienteUnico' + '=' +this.props.cliente;
        } else {
            directorio = directorio + 'origen' + '=' + 'corporativo';
        }

        return  directorio;
    }

    getClassName(){
        if((this.props && this.props.cliente)){
            return 'directorio-cliente'
        } else {
            return 'directorio-cliente-publico'
        }

    }


    render() {
        const propsComunes = {
            id:"directorio-frame",
			ref: "iFrame",
            frameBorder:"0",
            width:"100%",
            height: '700px',
            src: this.getSrcDirectorio(),
            className: this.getClassName(),
            allow:"geolocation"
        };
        
        return (
                <iframe
                    {...propsComunes}
                    onLoad={this.onLoadIframe}
                    name = {this.props.tid}
                />     
        )
    }
}

Directorio.propTypes = {
	loading: PropTypes.bool,
	paso: PropTypes.number,
	cliente: PropTypes.string,
	tid: PropTypes.string
}

export default connect(mapState, mapDispatch)(Directorio);



// WEBPACK FOOTER //
// ./src/directorio/directorio.cmpt.js